export const formatDateTime = (dateString: string) => {
    // Удаляем 'Z' и принудительно добавляем '+05:00'
    const localDateString = dateString.replace('Z', '+05:00');
    const date = new Date(localDateString);

    return date.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Asia/Yekaterinburg',
    });
};

export function getTimezoneShiftedISOString(hoursToAdd: number): string {
    const now = new Date();
    now.setHours(now.getHours() + hoursToAdd);
    return now.toISOString();
}

export function safeTimestamp(raw?: string): string {
    const hoursToAdd = 5;

    // Если timestamp не передан, используем текущий момент и сразу +5 часов
    if (!raw) {
        const shifted = new Date(Date.now() + hoursToAdd * 60 * 60 * 1000);
        return shifted.toISOString();
    }

    try {
        // Удалим лишние наносекунды и создадим Date
        const normalized = raw.replace(/(\.\d{3})\d+/, '$1');
        const date = new Date(normalized);

        if (isNaN(date.getTime())) {
            const fallback = new Date(Date.now() + hoursToAdd * 60 * 60 * 1000);
            return fallback.toISOString();
        }

        // Смещаем на +5 часов
        date.setHours(date.getHours() + hoursToAdd);

        // Возвращаем ISO в UTC, как требует store
        return date.toISOString();
    } catch {
        const fallback = new Date(Date.now() + hoursToAdd * 60 * 60 * 1000);
        return fallback.toISOString();
    }
}

export function safeTimestampTwo(raw?: string): string {
    if (!raw) return new Date().toISOString();

    try {
        // Преобразуем "2025-06-03 14:30:30" → "2025-06-03T14:30:30.000Z"
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(raw)) {
            raw = raw.replace(' ', 'T') + '.000Z';
        }

        // Убираем наносекунды, оставляем только 3 цифры после точки
        raw = raw.replace(/(\.\d{3})\d+/, '$1');

        const date = new Date(raw);
        if (isNaN(date.getTime())) {
            console.warn('⚠️ Неверный формат timestamp:', raw);
            return new Date().toISOString();
        }

        return date.toISOString();
    } catch (err) {
        console.warn('⚠️ Ошибка парсинга времени:', raw, err);
        return new Date().toISOString();
    }
}

export const normalizeTimestamp = (timestamp: string): string => {
    // Отсекаем наносекунды — оставляем только миллисекунды
    return timestamp.replace(/(\.\d{3})\d+/, '$1');
};
